module.exports = __webpack_public_path__ + "static/media/9-ano.cb1dff78.png";